//TODO: edit as per API req,response
import { Commit, ActionTree } from 'vuex';
import { State } from '@/store/modules/k8/node/node.store';
import { AxiosResponse } from 'axios';
import graphQl from '@/services/graphQl';

const actions: ActionTree<State, any> = {
  async GET_NODE_CARD_DATA(
    context: { commit: Commit },
    params: {
      serviceId: string;
      clientIp: Array<string[]>;
      duration: {
        start: String;
        end: String;
        step: String;
      };
      NodeMetricNamesList: Array<string[]>;
    },
  ): Promise<any> {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryNodeMetricsData')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.NodeMetricsData;
        } else return [];
      })
      .catch((err) => {
        console.log('Error', err);
      });
  },
};

export default actions;
